export default __webpack_public_path__ + "static/media/mp-diamante.e99a0d31.svg";